<template>
<!-- <div class="sidebar-footer"></div> -->
</template>
<script>
export default {
  name: 'sidebar-footer'
}
</script>



// WEBPACK FOOTER //
// SidebarFooter.vue?232f999c